
import { defineComponent, onMounted, computed, ref } from "vue";
import { getCSSVariableValue } from "@/assets/ts/_utils";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { ConsentsEvolutionGraph } from "@/core/services/consensu/consents";

export default defineComponent({
  name: "ConsentsEvolution",

  props: {
    widgetClasses: String,
  },

  components: {},

  setup() {
    const store = useStore();
    const route = useRoute();

    const period = ref("day");

    const graphData = ref();
    const series = ref();
    const options = ref();

    const loadingState = ref(true);

    const labelColor = getCSSVariableValue("--bs-gray-500");
    const borderColor = getCSSVariableValue("--bs-gray-200");
    const baseColor = getCSSVariableValue("--bs-info");

    onMounted(() => {
      getConsentsEvolution();
    });

    const owner = computed(() => {
      return store.getters.currentUser._id;
    });

    const changePeriod = (newPeriod) => {
      period.value = newPeriod;

      getConsentsEvolution();
    };

    const checkPeriod = (validatePeriod) => {
      return period.value == validatePeriod;
    };

    const getIdx = async (item) => {
      switch (period.value) {
        case "month":
          return `${("00" + item._id.month).slice(-2)}/${item._id.year}`;
        case "week":
          return `${item._id.week + 1} - ${("00" + item._id.month).slice(-2)}/${
            item._id.year
          }`;
        case "day":
          return `${item._id.day}/${("00" + item._id.month).slice(-2)}/${
            item._id.year
          }`;
      }
    };

    const getConsentsEvolution = async () => {
      loadingState.value = true;

      graphData.value = await ConsentsEvolutionGraph(
        owner.value,
        period.value,
        route.params.id
      );

      series.value = [
        {
          name: "Visualizações",
          data: graphData.value.data?.views.map((item) => {
            return item.count;
          }),
        },
        {
          name: "Consentimentos",
          data: graphData.value.data?.consents.map((item) => {
            return item.count;
          }),
        },
      ];

      let viewsKeys = {};

      await graphData.value.data?.views.forEach(async (item) => {
        let idx = (await getIdx(item)) as any;
        // console.log("IDX", idx);
        viewsKeys[idx] = item.count;
      });

      options.value = {
        chart: {
          fontFamily: "inherit",
          type: "area",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {},
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
          // opacity: 1,
        },
        stroke: {
          curve: "smooth",
          show: true,
          width: 3,
          colors: ["#20d489", "#00a3ff"],
        },
        xaxis: {
          categories: Object.keys(viewsKeys),
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              colors: labelColor,
              fontSize: "12px",
            },
          },
          crosshairs: {
            position: "front",
            stroke: {
              color: baseColor,
              width: 1,
              dashArray: 3,
            },
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: labelColor,
              fontSize: "12px",
            },
          },
        },
        states: {
          normal: {
            filter: {
              type: "none",
              value: 0,
            },
          },
          hover: {
            filter: {
              type: "none",
              value: 0,
            },
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: "none",
              value: 0,
            },
          },
        },
        tooltip: {
          style: {
            fontSize: "12px",
          },
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        colors: ["#20d489", "#00a3ff"],
        grid: {
          borderColor: borderColor,
          strokeDashArray: 4,
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        markers: {
          strokeColor: ["#20d489", "#00a3ff"],
          strokeWidth: 3,
        },
      };

      loadingState.value = false;
    };

    return {
      options,
      series,
      loadingState,
      changePeriod,
      checkPeriod,
    };
  },
});
